export * from './alert'
export * from './country'
export * from './countryCodes'
export * from './directionCalculator'
export * from './number'
export * from './url'
export * from './utmParams'
export * from './trackRegistration'
export * from './customerSearchFn'
export * from './convertDateOfOverdueReceivable'
export * from './utils'

export function setDocumentTitle(title) {
  try {
    document.title = title ? `BlueTape - ${title}` : 'BlueTape'
  } catch (e) {}
}
